/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAttachmentRequest
 */
export interface GetAttachmentRequest {
    /**
     * 
     * @type {number}
     * @memberof GetAttachmentRequest
     */
    aktid?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAttachmentRequest
     */
    versionId?: number;
}

export function GetAttachmentRequestFromJSON(json: any): GetAttachmentRequest {
    return GetAttachmentRequestFromJSONTyped(json, false);
}

export function GetAttachmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttachmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktid': !exists(json, 'aktid') ? undefined : json['aktid'],
        'versionId': !exists(json, 'versionId') ? undefined : json['versionId'],
    };
}

export function GetAttachmentRequestToJSON(value?: GetAttachmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktid': value.aktid,
        'versionId': value.versionId,
    };
}


